import React from 'react';
import moment from "moment";
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Row,Col,Button,Calendar,Icon,Form,Input,message,Modal } from 'antd';

import { fetchMyAttendanceDetail } from "../../actions/employee-actions";
import myAttendance from '../../services/Employee/my-attendance-service';


const iconMap = [
	{icon: "", title: ""},
	{icon: "clock-circle-o", title: "迟到"},
	{icon: "clock-circle", title: "早退"},
	{icon: "warning", title: "未打卡"},
	{icon: "close-circle-o", title: "旷工"},
	{icon: "sync", title: "调休"},
	{icon: "down-circle-o", title: "正常"}
];
const FormItem = Form.Item;
const { TextArea } = Input;
class MyAttendanceDetail extends React.Component {

	state = {
		defaultDate:moment(this.props.routing.location.pathname.split('/')[3]),
		currentSelectDate:this.props.routing.location.pathname.split('/')[3],
		currentModalStatus: false,
		on_time: "",
		off_time:""
	}
	componentWillMount () {
		// console.log(this.props.routing.location.pathname.split('/')[3]);
		let date = {
			// calendar_date: moment().format('YYYY-MM')
			attendance_date:this.props.routing.location.pathname.split('/')[3]
		}
		this.setState(date);
		this.props.fetchMyAttendanceDetail(date);
		// console.log(this.props.employee.myAttendance)
		setTimeout(() => console.log(this.props.employee), 3000)
	}
	
	onPanelChange = moment => {
		let date = {
			attendance_date: moment.format('YYYY-MM')
		}
		this.setState(date);		
		this.props.fetchMyAttendanceDetail(date);
	}
	dateCellRender = moment => {
		// console.log(this.props.employee.myAttendance.data)
		// let title = "";
		// let content = "";
		let type = 0;
		this.props.employee.myAttendance.data.forEach(date => {
			if (date.calendar_date === moment.format('YYYY-MM-DD')) {
				// title = date.title;
				// content = date.content;
				if(date.status === 10){
					type = 6
				}
				else{
					type = date.status;
				}	
			}
		})
		return (
			<div>
				<div>
					<Icon type={iconMap[type].icon} style={{marginLeft: "2px", color: type === 6 ? "" : "red"}} />
				</div>
			</div>
		)
	}
	onSelect = moment => {
		// console.log(moment.format("YYYY-MM-DD"))
		this.setState({
			currentSelectDate:moment.format("YYYY-MM-DD"),
			currentData:1
		})
		// console.log(this.state.currentData);
		this.props.employee.myAttendance.data.forEach(date => {
			if (date.calendar_date === moment.format('YYYY-MM-DD')) {
				this.setState({
					currentData: {
						...date,
						icon: iconMap[date.calendar_type]
					}
				})
				return;
			}
		})
		// console.log(this.props.employee.myAttendance.data)
		// console.log(this.state.currentData)
	}
	closeCurrentModal = () => {
		this.setState({
			currentModalStatus: false
		});
	}
	customHandle = () => {
		// console.log("kkkkkkkkkk");
		// console.log(this.state.currentData.calendar_date);
		this.setState({
			currentModalStatus: true,
			attendance_date: this.state.currentData.calendar_date,
			schedule_id: this.state.currentData.schedule_id,
			on_time: this.state.currentData.on_time_str,
			off_time:this.state.currentData.off_time_str,
			attendance_status:this.state.currentData.status,
		});
		// this.setState({currentData: this.props.employee.myAttendance[index]});
	}
	submitCurrentModal = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			const currentData = {
				attendance_date: this.state.attendance_date,
				schedule_id: this.state.schedule_id,
				on_time: this.state.on_time,
				off_time:this.state.off_time,
				attendance_status:this.state.attendance_status,
				complaint_content:values.complaint_content
			}
			console.log(currentData);
			myAttendance.fetchAttendanceComplaint(currentData, res => {
				if (res.data.Success) {
					message.success("申诉操作成功", 4);
					this.props.form.resetFields();
					this.setState({
						currentModalStatus: false
					});
				} else if(res.data.Errors){
					message.error(`申诉操作失败：${res.data.Errors}`);
				} else {
					message.error(`申诉操作失败：${res.data.Message}`);
				}
			}, err => {});
			// const callee = this.state.isApproval ? () => {} : () => {}
			// callee(currentData);
		}
	})

	render() {
		return (
			<div className="app-module-item">
				
				<Row>
					<Col lg={24} xl={12} style={{marginBottom: "15px"}}>
						<div className="attendance-calendar" style={{border: "1px solid #e5e5e5", borderRadius: "3px"}}>
							<Calendar fullscreen={true}
								dateCellRender={this.dateCellRender}
						    	onPanelChange={this.onPanelChange} 
								onSelect={this.onSelect} 
								defaultValue={this.state.defaultDate}
							/>
						</div>
					</Col>
					<Col lg={24} xl={12} style={{marginBottom: "15px"}}>
						<div className="attendance-calendar" style={{border: "1px solid #e5e5e5", borderRadius: "3px",paddingTop:"10px"}}>
							<span style={{height: "40px", lineHeight: "40px",margin: "0px 15px"}}>注:</span>
							{iconMap.map(icon => (
								<span key={icon.icon} style={{margin: "15px",fontSize:"14px"}}>
									<Icon type={icon.icon}> {icon.title}</Icon>
								</span>
							))}
						</div>
						{this.state.currentData && this.state.currentData!==1 ? 
						<div style={{padding: "15px"}}>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>考勤日期:</span>
								<span>{ this.state.currentSelectDate }</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>应该出勤时间:</span>
								<span>{ this.state.currentData.should_attendance_time }</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>签到时间:</span>
								<span>{ this.state.currentData.on_time_str }</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>签出时间:</span>
								<span>{ this.state.currentData.off_time_str }</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>调休时间:</span>
								<span>{ this.state.currentData.relaxation_hours }</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>加班时间:</span>
								<span>{ this.state.currentData.overtimes_hours }</span>
							</div>
						</div>
						:
						<div style={{padding: "15px"}}>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>考勤日期:</span>
								<span>暂无数据</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>应该出勤时间:</span>
								<span>暂无数据</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>签到时间:</span>
								<span>暂无数据</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>签出时间:</span>
								<span>暂无数据</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>调休时间:</span>
								<span>暂无数据</span>
							</div>
							<div style={{marginBottom: "10px"}}>
								<span style={{paddingRight: "15px"}}>加班时间:</span>
								<span>暂无数据</span>
							</div>
						</div>
						}
						{this.state.currentData&&
						<div style={{textAlign: "center"}}>
							{Object.keys(this.state.currentData).length > 0 && this.state.currentData.status !== 10 && 
								<Button type="primary"
							style={{width: "120px"}}
							onClick={this.customHandle}>申诉</Button>}
						</div>}
					</Col>
				</Row>

				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title="考勤申诉"
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					onOk={this.submitCurrentModal}>
					<div style={{textAlign: "",margin:"10px 20px"}}>
						{this.state.currentData && 
						<Form onSubmit={this.submitCurrentModal} className="login-form" layout="inline">
							<div className="myAttendanceModal">
								<FormItem label="应该出勤时间">
									{this.state.currentData.should_attendance_time}
								</FormItem>
							</div>
							<div className="myAttendanceModal">
								<FormItem label="签到时间">
									{this.state.currentData.on_time_str}
								</FormItem>
							</div>
							<div className="myAttendanceModal">
								<FormItem label="签出时间">
									{this.state.currentData.off_time_str}
								</FormItem>
							</div>	
						    
							<div className="myAttendanceModal">
						        <FormItem label="申诉描述">
									{this.props.form.getFieldDecorator('complaint_content', {
									rules: [{ required: true, message: '请填写申诉描述'}],
									initialValue: this.state.currentData.complaint_content
									})(<TextArea rows={4} style={{width:"420px"}}/>)}
								</FormItem>
							</div>
						</Form>
						}
					</div>
				</Modal>
				
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		employee: state.employee,
		routing: state.routing
	}
}

const mapDispatchToProps = {
	fetchMyAttendanceDetail
}

MyAttendanceDetail = Form.create()(MyAttendanceDetail);
export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(MyAttendanceDetail));




// WEBPACK FOOTER //
// ./src/routes/Employee/MyAttendanceDetail.js